module.exports = __webpack_public_path__ + "img/02.aa420040.jpg";